import { render, staticRenderFns } from "./u-header-fixed-scroll.vue?vue&type=template&id=3e2ef2b6&scoped=true"
import script from "./u-header-fixed-scroll.vue?vue&type=script&lang=js"
export * from "./u-header-fixed-scroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2ef2b6",
  null
  
)

export default component.exports